import {toCamelCaseProperties} from '@/utils/fn';

export default class WebshopBundle {
   constructor(args) {
      args = toCamelCaseProperties(args) || {};
      this.id = args.id;
      this.name = args.name;
      this.description = args.description;
      this.imgUrl = args.imgUrl || 'http://res.cloudinary.com/odin-systemer/image/upload/h_550,w_550,c_lpad,b_white,d_defaults:d_product.png/v1459843120/supplierProduct/3861.jpg'
      this.price = getCampaignValue(args.products) || 0;
      this.originalPrice = getTotalValue(args.products) || 0;
      this.products = args.products,
      this.maxPerCustomer = args.maxPerCustomer,
      this.stockAmount = args.stockAmount,
      this.subscriptions = args.subscriptions
      this.toDate = args.toDate || args.campaignDateTo
      // this.salesPrice = args.salesPrice || 0;
   }  
}



function getTotalValue(products){
   let value = 0
   products.forEach(p => {
     return value += p.Price
   });
 
   return value
 }
 
 function getCampaignValue(products){
   let value = 0
   products.forEach(p => {
     return value += p.SalesPrice
   });
 
   return value
 }